import { toonAantal, type Item } from '@boodschappenlijst/shared';
import type { ProductFormWaarden } from '../../components/ProductForm';

interface Props {
  match: Item;
  nieuw: ProductFormWaarden;
  bezig: boolean;
  onSamenvoegen: () => void;
  onApart: () => void;
  onAnnuleren: () => void;
}

/** Gevraagd vóór het toevoegen, als er al een regel voor hetzelfde product
 *  openstaat: erbij optellen of toch als losse regel erbij. */
export function DuplicaatDialog({
  match,
  nieuw,
  bezig,
  onSamenvoegen,
  onApart,
  onAnnuleren,
}: Props) {
  return (
    <div className="vs-overlay" role="dialog" aria-modal="true" aria-labelledby="dup-titel">
      <div className="vs-card vs-dialog">
        <h2 className="vs-dialog__title" id="dup-titel">
          Staat er al op
        </h2>
        <p className="vs-dialog__body">
          <strong>{match.naam}</strong> ({toonAantal(match.aantal, match.eenheid)}) staat al op de lijst,
          toegevoegd door {match.toegevoegdDoor}. Wil je jouw{' '}
          {toonAantal(nieuw.aantal, nieuw.eenheid)} erbij optellen, of er een aparte regel van maken?
        </p>
        <div className="vs-dialog__actions">
          <button className="vs-btn vs-btn--ghost" onClick={onAnnuleren} disabled={bezig}>
            Annuleren
          </button>
          <button className="vs-btn vs-btn--ghost" onClick={onApart} disabled={bezig}>
            Apart toevoegen
          </button>
          <button className="vs-btn" onClick={onSamenvoegen} disabled={bezig}>
            Erbij optellen
          </button>
        </div>
      </div>
    </div>
  );
}
